type Props = {
  children: React.ReactNode;
};

function ButtonGroup({ children }: Props) {
  return <div className="button-group">{children}</div>;
}

export default ButtonGroup;
